import { useState, useEffect } from "react";
//https://gist.github.com/joshcawthorne/0a518b164658510f4eed74d0c4e8d003

function useWindowSize(defaultValues) {
  defaultValues = {
    width: undefined,
    height: undefined,
    isDesktop: undefined,
    isDesktopMinusOne: undefined,
    bgBoundarySurpassed: undefined,
    ...defaultValues,
  };

  const [windowSize, setWindowSize] = useState(defaultValues);

  useEffect(() => {
    if (typeof window !== undefined) {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
          isDesktop: window.innerWidth > 992,
          isDesktopMinusOne: window.innerWidth > 991,
          isMdMinusOne: window.innerWidth > 767,
          bgBoundarySurpassed: window.innerWidth > 600,
        });
      }
      window.addEventListener("resize", handleResize, {
        passive: true, // it won't call preventDefault, so we can use passive:true for better performance
      });
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return windowSize;
}

export default useWindowSize;
